var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "room-service 1",
    clipPath: "url(#clip0_83_5149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5833 17.9167V16.0833C21.58 13.5692 20.6384 11.1469 18.943 9.29049C17.2475 7.43411 14.9202 6.27738 12.4167 6.04675V4.82942C12.7662 4.62763 13.0393 4.31615 13.1938 3.94329C13.3482 3.57043 13.3753 3.15703 13.2709 2.7672C13.1664 2.37738 12.9362 2.03291 12.6161 1.78722C12.2959 1.54154 11.9036 1.40837 11.5 1.40837C11.0964 1.40837 10.7041 1.54154 10.3839 1.78722C10.0638 2.03291 9.83359 2.37738 9.72914 2.7672C9.62468 3.15703 9.65178 3.57043 9.80622 3.94329C9.96066 4.31615 10.2338 4.62763 10.5833 4.82942V6.04675C8.07982 6.27738 5.75252 7.43411 4.05704 9.29049C2.36156 11.1469 1.42 13.5692 1.41667 16.0833V17.9167C1.17355 17.9167 0.940394 18.0132 0.768485 18.1852C0.596577 18.3571 0.5 18.5902 0.5 18.8333C0.5 19.0764 0.596577 19.3096 0.768485 19.4815C0.940394 19.6534 1.17355 19.75 1.41667 19.75H21.5833C21.8264 19.75 22.0596 19.6534 22.2315 19.4815C22.4034 19.3096 22.5 19.0764 22.5 18.8333C22.5 18.5902 22.4034 18.3571 22.2315 18.1852C22.0596 18.0132 21.8264 17.9167 21.5833 17.9167ZM3.25 16.0833C3.68358 5.14383 19.3201 5.15208 19.75 16.0833V17.9167H3.25V16.0833Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_5149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomService);
export default __webpack_public_path__ + "static/media/room-service.1738065094d5d3e390c0f960ac2b1bf3.svg";
export { ForwardRef as ReactComponent };